import getCompositionsStore from 'actions/customer/lib/get_compositions_store';

export default class SetRecipients {
  constructor(context) {
    this.context = context;
  }

  run({ compositionId, recipients }) {
    const compositionsStore = getCompositionsStore(this.context);
    const composition = compositionsStore.findBy({ id: compositionId });
    composition.content.setRecipients(recipients);
    compositionsStore.replace(composition);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composer/email/set_recipients.js